import CityPageTemplate from "../city-template/CityPageTemplate";
import { pasadenaTXConfig } from "./data";

export default function PasadenaTXPage() {
  return <CityPageTemplate config={pasadenaTXConfig} />;
}